// Contact Form Handler

( function( $, window, document, undefined ) {
  
  let $contactForm = $('#contact');

  if ( $contactForm.length ) {
    let _contactFormController = new ContactFormController( $contactForm );

    // Stop the browser showing it's default error handling UI, only when the JS has loaded
    $contactForm.attr( 'novalidate', 'true' );

    // Listen for bubbled events from button
    // Submit events fire default HTML5 validation as well
    $contactForm.find('#contact_submit').on( 'click', (event) => {

      if ( !_contactFormController.validate() ) {

        // Scroll to and focus first error
        let errorFound = false;
        $.each( _contactFormController.fields, ( index, field ) => {
          if ( field.hasError && !errorFound ) {
            // Force offset so that whole form element is showing
            window.SmoothScroll.setTempOffset(-100).toElement( field.$field ).restoreOffset();
            field.$field.focus();

            errorFound = true;
          }
        } );

        event.preventDefault();
        return false;

      }

    } );

    $contactForm.on( 'submit', (event) => {
      $contactForm.find('#contact_submit').html( 'Sending&hellip;' );
    } );
  }

  // Listen for change events and hide field errors
  $contactForm.find('input, textarea, select').on( 'change', (event) => {
    let $this = $(event.target),
        formField = new FormField( $this );

    $this.trigger( 'removeError' );
  } );

} )( jQuery, window, document );
